export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'P5VqAcSA9JUFwDLs49mfSW6CRQSvD73p',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'P5VqAcSA9JUFwDLs49mfSW6CRQSvD73p',
        audience: 'https://crew-time/api',
    }
}